import React from 'react';
import { FontIcon, Label, mergeStyleSets } from '@fluentui/react';
import theme from '../../../theme';
import { BRAND_PURPLE } from './PurchaseOrderPanelParts';

// Opvallende keuze Bestelbon / Prijsaanvraag. Vervangt de kleine Toggle, zodat
// duidelijk is wat de leverancier ontvangt (een bestelling of een offerteaanvraag).

const QUOTE_COLOR = BRAND_PURPLE; // 3bouw-paars

const classes = mergeStyleSets({
  group: {
    display: 'inline-flex',
    border: `1px solid ${theme.palette.neutralSecondary}`, // zoals de invulvelden
    borderRadius: 2,
    overflow: 'hidden',
  },
  option: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '0 14px',
    height: 32, // zelfde hoogte als de invulvelden
    border: 'none',
    background: theme.palette.white,
    color: theme.palette.neutralSecondary,
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
    selectors: {
      ':hover': { background: theme.palette.neutralLighter },
      ':focus-visible': { outline: `2px solid ${theme.palette.neutralPrimary}`, outlineOffset: -2 },
    },
  },
  divider: {
    borderLeft: `1px solid ${theme.palette.neutralSecondary}`,
  },
  selectedOrder: {
    background: theme.palette.themePrimary,
    color: theme.palette.white,
    selectors: { ':hover': { background: theme.palette.themeDarkAlt } },
  },
  selectedQuote: {
    background: QUOTE_COLOR,
    color: theme.palette.white,
    selectors: { ':hover': { background: '#3f1253' } },
  },
  hint: {
    marginTop: 4,
    fontSize: 12,
    fontWeight: 600,
  },
});

type Props = {
  isPurchaseOrder: boolean;
  onChange: (isPurchaseOrder: boolean) => void;
  disabled?: boolean;
};

const PurchaseOrderTypeSwitch: React.FC<Props> = ({ isPurchaseOrder, onChange, disabled }) => {
  const option = (value: boolean, text: string, icon: string) => {
    const selected = isPurchaseOrder === value;
    const selectedClass = value ? classes.selectedOrder : classes.selectedQuote;
    return (
      <button
        type='button'
        role='radio'
        aria-checked={selected}
        disabled={disabled}
        className={`${classes.option} ${selected ? selectedClass : ''} ${value ? '' : classes.divider}`}
        onClick={() => !selected && onChange(value)}
      >
        <FontIcon iconName={icon} />
        {text}
      </button>
    );
  };

  return (
    <div>
      <Label>Type bon</Label>
      <div className={classes.group} role='radiogroup' aria-label='Type bon'>
        {option(true, 'Bestelbon', 'ShoppingCart')}
        {option(false, 'Prijsaanvraag', 'Comment')}
      </div>
      <div
        className={classes.hint}
        style={{ color: isPurchaseOrder ? theme.palette.themeDark : QUOTE_COLOR }}
      >
        {isPurchaseOrder
          ? 'De leverancier ontvangt een bestelling.'
          : 'De leverancier ontvangt een offerteaanvraag, geen bestelling.'}
      </div>
    </div>
  );
};

export default PurchaseOrderTypeSwitch;
